
export const CHECKOUT_STEPS = {
  COLLECTION_VIEW: 0,
  CHECKOUT: 1,
  SUCCESS: 2,
  MOBILE_CHECKOUT: 4
};

